<template>
	<span class="card-info-item lesson-difficulty">
		<i class="tbb-icon-spoon"></i>
		<i class="tbb-icon-spoon" :class="{ 'inactive' : item.difficulty_number < 2 }"></i>
		<i class="tbb-icon-spoon" :class="{ 'inactive' : item.difficulty_number < 3 }"></i>
		{{ item.difficulty_name }}
	</span>
</template>

<script>
	module.exports = {
		props: ['item'],

		data() {
			return {}
		},
	}
</script>
